import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux/store';
import { AuthPanel } from './views/AuthPanel';

const LayoutComponent = () => (
	<Provider store={store}>
		<Background />
		<AuthPanel />
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Login)
	.build();

export default Layout;
